import { InsuranceType, SelectedInsuranceFragment } from '@websky/graphql';

export const hasPaidInsuranceByType = (selectedInsurance: SelectedInsuranceFragment[], types: InsuranceType[]) => {
	return selectedInsurance?.some(
		insurance => types.includes(insurance?.insuranceProgram?.type) && !!insurance?.policyNumber
	);
};
